<template>
  <div class="role">
    <div class="right-wrap">
      <div class="query-wrap">
        <!-- <div class="query-date">
					<div class="query-date-label">预约时间</div>
					<el-date-picker
					  v-model="dateValue"
					  type="daterange"
					  value-format="timestamp"
					  range-separator="~"
					  start-placeholder="开始日期"
					  end-placeholder="结束日期"
					  @change="searchDateChange">
					</el-date-picker>
				</div> -->
        <div class="query-date">
          <div class="query-date-label">筛选</div>
          <el-select v-model="searchValue" @change="handleSearch" placeholder="请选择">
            <el-option v-for="item in searchOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- <el-button class="query-btn" @click="getReport">筛选</el-button> -->
      </div>
      <el-table :data="tableData" @selection-change="handleSelectionChange" class="list">

        <!-- :height="mainHeight - 166 + 'px'" -->
        <template slot="empty">
          <div class="empty-wrap">
            <el-image class="empty-img" :src="require('@/assets/images/empty-appoint.png')"></el-image>
            <div class="empty-text">暂无数据</div>
          </div>
        </template>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="编号" class-name="id" width="80"></el-table-column>
        <el-table-column prop="mobile" label="手机号" class-name="mobile">
          <template slot-scope="scope">
            {{ scope.row.mobile ? scope.row.mobile : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="id_card" label="身份证号" class-name="id_card">
          <template slot-scope="scope">
            {{ scope.row.id_card ? scope.row.id_card : '--' }}
          </template>
        </el-table-column>

        <el-table-column prop="package" label="套餐内容" class-name="package">

        </el-table-column>

        <el-table-column prop="created_at" label="日期" class-name="created_at">
        </el-table-column>
        <el-table-column prop="sort" label="次数" class-name="mobile">
          <template slot-scope="scope">
            {{ scope.row.sort ? '第' + scope.row.sort + '次' : '' }}/{{ scope.row.count ? '总' + scope.row.count + '次' : ''
            }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="foot-pagination">
        <el-row :gutter="20" v-show="downFile">
          <el-col :span="12">
            <button type="submit" class="download-excel nextBtn" @click="downExcel">批量导出</button>
            <form :action="http" method="post" autocomplete="off" v-show="false">
              <!-- <input type="text" name="startat" :value="dateValue.length > 0 ? dateValue[0] / 1000 : ''" />
							<input type="text" name="endat" :value="dateValue.length > 0 ? dateValue[1] / 1000 : ''" /> -->
              <input type="text" name="type" :value="searchValue" />
              <input type="text" name="act" value="gagc" />
              <!-- <input type="text" name="ids" :value="selectList" /> -->
              <button type="submit" ref="down">批量导出</button>
            </form>
          </el-col>
        </el-row>
      </div>
      <el-pagination v-if="pageCount > 10" :current-page.sync="pageNum" hide-on-single-page
        @current-change="handleCurrentChange" prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper"
        :page-size="10" :total="pageCount"></el-pagination>
    </div>
    <Alertb :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
      @on-confirm="confirmDialog" />

  </div>
</template>

<script>
// import gagc from '@/assets/js/gagc';
import Alertb from '@/components/alertb';
import { api, getGagc } from "@/utils/axios";
import el from "element-ui/src/locale/lang/el";
import axios from 'axios'  //这里引入axios  mian无需再引
import Vue from "vue";    //引入Vue
Vue.prototype.$ajax = axios;  //修改ajax原型指向为 axios
import Qs from 'qs';


export default {
  components: {
    Alertb
  },
  name: 'entGagc',
  data () {
    return {
      phone: false,
      dateValue: '',
      pickerBeginDateBefore: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      tableData: [],
      multipleSelection: [],
      pageCount: 1,
      pageNum: 0,
      dateEdit: '',
      dateEditChange: false,

      createdTimeW: 0,
      usernameW: 0,
      finishW: 0,
      phoneW: 0,
      user_idW: 0,
      packageW: 0,
      identW: 0,
      mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,

      pickerOptions: {
        disabledDate (time) {
          let _now = Date.now(),
            min = 3 * 24 * 60 * 60 * 1000,
            max = 14 * 24 * 60 * 60 * 1000,
            minDays = _now + min,
            maxDays = _now + max;

          return time.getTime() < minDays || time.getTime() > maxDays;
          //大于当前的禁止，小于7天前的禁止
        }
      },
      searchValue: '0',
      searchOptions: [
        {
          value: '0',
          label: '全部',
        },
        {
          value: '1',
          label: '免费',
        },
        {
          value: '2',
          label: '付费',
        },
        // {
        // 	value: '2',
        // 	label: '专业评估版',
        // },
        // {
        // 	value: '3',
        // 	label: '专业增值版2.0',
        // },
      ],
      value: '0',
      http: api + 'v1/admin/exportExcel/',
      showDate: '',
      tipStatus: "",
      tipText: "",
      alertShow: false,
      downFile: false,
      selectList: [],
    }
  },

  mounted () {
    this.resizeChange();
    window.onresize = () => {
      return (() => {
        this.resizeChange()
      })();
    };
    let minDate = new Date();
    minDate.setDate(minDate.getDate() + 4);
    this.showDate = minDate;

    getGagc({
      // act: 'appoint',
      // startat: '',
      // endat: '',
      type: this.searchValue,
      page: 1,
      pagesize: 10
    }).then((res) => {
      if (res.code == 200) {
        if (res.data.data != '') {
          this.pageCount = parseInt(res.data.pager.count);


          this.tableData = res.data.data;

          this.downFile = true;
        } else {
          this.alertShow = true;
          this.tipStatus = "查询结果";
          this.tipText = "暂无数据";
          this.tableData = res.data.data;

          this.downFile = false;
        }

      }
    })
  },
  methods: {
    // 预约日期默认显示上一个月
    defaultDate () {
      let now = new Date(),
        y = now.getFullYear(),
        m = now.getMonth() + 1,
        d = now.getDate();
      return y + '/' + (m > 0 ? m - 1 : 12) + '/' + d;
    },
    handleSelectionChange (val) {
      let list = [];
      if (val && val.length > 0) {
        // 处理选中列表为选中Id列表
        val.map((item, index) => {
          list.push(item.id);
        });
      }
      this.selectList = list; //选中Id列表
    },

    dateChange (time) {
      this.dateEditChange = true;

      let week = new Date(time);
      if (week.getDay() == '0') {

        this.alertShow = true;
        this.tipStatus = "查询失败";
        this.tipText = "请选择周日以外的日期";
      }
    },
    resizeChange () {
      let tableWidth = document.getElementsByClassName('el-table__body-wrapper')[0].offsetWidth;
      this.createdTimeW = tableWidth * 0.1;
      this.usernameW = tableWidth * 0.1;
      this.finishW = tableWidth * 0.07;
      this.phoneW = tableWidth * 0.11;
      this.identW = tableWidth * 0.18;
      this.user_idW = tableWidth * 0.10;
      this.packageW = tableWidth * 0.09;
    },

    handleCurrentChange (val) {
      this.pageNum = val;
      this.reportCommit(val);
    },
    reportCommit (val) {
      let data = {
        // act: 'appoint',
        // startat: this.dateValue ? this.dateValue[0] / 1000 : '',
        // endat: this.dateValue ? this.dateValue[1] / 1000 + 86399 : '',
        type: this.searchValue,
        page: val,
        pagesize: 10
      };
      getGagc(data).then((res) => {
        if (res.code == 200) {
          if (res.data.data != '') {
            this.pageCount = parseInt(res.data.pager.count);


            this.tableData = res.data.data;

            this.downFile = true;
          } else {
            this.alertShow = true;
            this.tipStatus = "查询结果";
            this.tipText = "暂无数据";
            this.tableData = res.data.data;

            this.downFile = false;
          }

        }
      })
    },
    searchDateChange () {
      this.pageNum = 1
      this.reportCommit(1);

    },
    handleSearch () {
      this.pageNum = 1
      this.reportCommit(1);
    },
    getReport () {
      this.pageNum = 1
      this.reportCommit(1);
    },

    downExcel () {
      // 			if(this.selectList.length <= 0) {

      // 				this.alertShow = true;
      // 				this.tipStatus = "下载失败";
      // 				this.tipText = "请选择要导出的数据";
      // 			}else {
      // 				this.$refs.down.click();

      // 			}
      this.$refs.down.click();
      // if (this.dateValue == '' || this.dateValue[0] / 1000 == this.dateValue[1] / 1000 || this.value == '') {
      //     this.alertShow = true;
      //     this.tipStatus = "下载失败";
      //     this.tipText = "请选择合适的起止日期及信息";
      // } else {
      //     this.$refs.down.click();

      // }
    },
    confirmDialog () {
      this.alertShow = false;
    },
    closeDialog () {
      this.alertShow = false;
      //把绑定的弹窗数组 设为false即可关闭弹窗
    },
  }
}
</script>

<style src="@/assets/iconFonts/iconfont.css" scoped></style>
<!-- <style src="@/assets/css/bookingInfo.css" scoped></style> -->
<style scoped>
.right-wrap>>>.el-table th {
  background-color: #F2F4FA;
}

.right-wrap>>>.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 380px;
}

.right-wrap>>>.el-date-editor .el-range-separator {
  color: #DBDDE6;
}

/* .right-wrap >>> .el-select-dropdown__item {
		padding: 0 20px !important;
	} */
</style>
<style lang="scss" scoped>
.role {
  display: flex;
  // padding: 24px;
  width: 100%;
  height: 100%;
  // border: 12px solid #F2F4FA;

  .left-menus {
    min-width: 170px;
    width: 170px;
    padding: 0 24px 30px;
    border-right: 1px solid #E5E8F5;
    background-color: #ffffff;

    .add-action {
      display: flex;
      align-items: center;
      cursor: pointer;

      .add-action-img {
        display: flex;
        align-items: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background-color: #6883FB;
        border-radius: 50%;

        &::after {
          content: "+";
          width: 100%;
          font-size: 20px;
          color: #fff;
          text-align: center;
          margin-bottom: 4px;
        }
      }

      .add-action-text {
        font-size: 14px;
        color: #6883FB;
        margin-left: 8px;
      }
    }

    .left-list {
      padding-top: 20px;
    }

    .left-enp-item {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #525866;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .left-enp-item-active {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #6883FB;
      cursor: pointer;
    }

    .enp-item-status {
      width: 20px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #7A8599;
      background-color: #E8E9EC;
      margin-right: 4px;
      padding-top: 1px;
      border-radius: 50%;
      text-align: center;
    }

    .enp-item-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .enp-item-status-active {
      width: 20px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6883FB;
      background-color: #E9EDFF;
      margin-right: 4px;
      padding-top: 1px;
      border-radius: 50%;
      text-align: center;
    }
  }

  .right-wrap {
    flex: 1;
    width: 100%;
    padding: 28px 24px;

    .query-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      padding-right: 1%;

      .query-package {
        width: 226px;
      }
    }

    .c-danger {
      color: #FF4C52;
    }

    .query-date {
      display: flex;
      align-items: center;
      margin-right: 150px;

      .query-date-label {
        margin-right: 10px;
      }
    }

    .query-btn {
      width: 96px;
      height: 34px;
      background: #6883FB;
      border-radius: 17px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      border: none;
    }

    .el-button:active {
      background-color: #5B73DC;
    }

  }

  .pagination {
    width: 100%;
    text-align: center;
  }

  .foot-pagination {
    // position: fixed;
    // bottom: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 1160px;
    max-width: 100%;
    width: 100%;
    height: 80px;
    background-color: #fff;
    z-index: 9;
  }

  .nextBtn {
    position: absolute;
    left: 24px;
    top: -20px;
    display: block;
    cursor: pointer;
    width: 96px;
    height: 34px;
    line-height: 34px;
    background: #6883FB;
    border-radius: 17px;
    border: none;
    color: white;
    outline: none;
    font-size: 14px;
  }

  .empty-wrap {
    padding: 100px 0;
  }

  .empty-img {
    width: 280px;
    height: 222px;
  }

}

.order_status_80 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  background-color: #5eb95e;
}

.order_status_1 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  background-color: #F37B1D;
}
</style>